<style>
.block-desc {
  margin: 30px 0;
}
.block-subscrable {
  padding-top: 30px;
  padding-bottom: 30px;
  border-radius: 3px;
  background-color: #0f0f16;
}
.block-subscrable .container {
  padding: 0 60px;
}
.block-subscrable .title {
  color: #fff;
  margin-top: -10px;
}
.block-subscrable .title h3 {
  font-size: 24px;
  font-weight: 400;
  line-height: 1.5em;
  letter-spacing: 0px;
  color: #eee;
  margin-bottom: 5px;
}
.block-subscrable .title p {
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  color: #999;
  margin-bottom: 0;
}
.block-subscrable .link_holder {
  text-align: right;
}
.block-subscrable .link_holder a {
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 50px;
  letter-spacing: 0.5px;
  color: #041230;
  background-color: #fff;
  text-decoration: none;
  padding: 10px 25px;
  border-radius: 2px;
}
.project-block > .row {
  justify-content: center;
  align-items: center;
}
.project-block > .row > div {
  padding: 0;
}
.project-block h3 {
  margin: 0px;
  padding: 0px;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0px;
  margin-bottom: 33px;
}
.project-block .item-img {
  padding: 0 5px;
  margin-bottom: 10px;
  display: block;
}
.project-block .item-img img {
  border-radius: 5px;
  object-fit: cover;
  width: 100%;
  height: 220px;
}
.project-page .project-block {
  padding: 50px 70px 50px 80px;
}
.project-block .list {
  width: 100%;
  float: left;
  clear: both;
}
.project-block .list ul {
  margin: 0px;
  list-style-type: none;
  margin-left: -30px;
  padding: 0;
}
.project-block .list ul li {
  width: 50%;
  float: left;
  padding-left: 30px;
  margin-bottom: 20px;
  box-sizing: border-box;
}
.project-block .list .item {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  padding-left: 35px;
  min-height: 18px;
}
.project-block .list .item img {
  position: absolute;
  width: 18px;
  height: 18px;
  color: #45a2df;
  top: 0px;
  left: 0px;
}
.project-block .list ul li p {
  margin-bottom: 0;
}
.project-page .title_holder {
  position: relative;
  padding: 95px 0 35px;
  width: 100%;
  float: left;
  clear: both;
}
.project-page .title_holder:before {
  bottom: 13px;
  width: 150px;
  border-radius: 10px;
}
.project-page .title_holder:after {
  bottom: 0;
  width: 70px;
  border-radius: 10px;
}
.project-page .title_holder:before,
.project-page .title_holder:after {
  left: 0;
  position: absolute;
  height: 6px;
  background-color: #eee;
  content: "";
}
.project-page .title_holder .breadcrumbs {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  padding-top: 13px;
  padding-bottom: 2px;
}
.project-page .title_holder .breadcrumbs ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.project-page .title_holder .breadcrumbs li {
  float: left;
  margin-bottom: 5px;
}
.project-page .title_holder .breadcrumbs li a {
  font-size: 14px;
  color: #666;
  text-decoration: none;
  letter-spacing: 0;
  line-height: 1.5;
  font-weight: 600;
}
.project-page .title_holder .breadcrumbs .separator span {
  width: 33px;
  height: 24px;
  display: block;
  position: relative;
}
.project-page .title_holder .breadcrumbs .separator span:after,
.project-page .title_holder .breadcrumbs .separator span:before {
  width: 9px;
  height: 2px;
  display: block;
  position: absolute;
  background-color: #ddd;
  left: 13px;
  content: "";
}
.project-page .title_holder .breadcrumbs .separator span:before {
  top: 14px;
  transform: rotate(135deg);
}
.project-page .title_holder .breadcrumbs .separator span:after {
  top: 8px;
  transform: rotate(45deg);
}
.project-footer {
  display: flex;
  justify-content: space-between;
}
.project-footer .btn {
  border-radius: 0;
}
</style>
<template>
  <div class="project-page">
    <div class="container">
      <div class="title_holder" v-if="currentItem">
        <h3>{{ currentItem.name[locale] }}</h3>
        <div class="breadcrumbs">
          <ul>
            <li class="item-home">
              <router-link class="bread-link bread-home" to="/" title="Home">{{
                $t("nav.main")
              }}</router-link>
            </li>
            <li class="separator separator-home">
              <span></span>
            </li>
            <li class="item-current">
              <router-link to="/projects" class="bread-current">{{
                $t("nav.projects")
              }}</router-link>
            </li>
            <li class="separator separator-home">
              <span></span>
            </li>
            <li class="item-current">
              <span class="bread-current">{{ currentItem.name[locale] }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row" v-if="currentItem">
        <div class="col-md-12">
          <div class="project-block">
            <div class="row">
              <VueGallery
                :images="imageTarget"
                :index="index"
                @close="index = null"
              ></VueGallery>
              <div
                v-for="(img, imgIndex) in currentItem.images"
                :key="imgIndex"
                class="col-md-4"
              >
                <a
                  class="item-img"
                  href="#"
                  @click="ChangeImage(imgIndex, img)"
                >
                  <img :src="img" />
                </a>
              </div>
            </div>
            <div class="col-md-12">
              <div
                class="block-desc"
                v-html="currentItem.description[locale]"
              ></div>
            </div>
            <div class="project-footer">
              <router-link
                v-if="prev.id"
                :to="'/' + locale + '/project/' + prev.id"
                class="btn btn-primary"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="26"
                  height="26"
                  viewBox="0 0 192 192"
                  style=" fill:#000000;"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,192v-192h192v192z" fill="none"></path>
                    <g fill="#ffffff">
                      <g id="surface1">
                        <path
                          d="M123.405,11.76c-1.005,0 -1.95,0.405 -2.67,1.11l-80.955,80.31c-1.515,1.5 -1.53,3.93 -0.03,5.43l80.31,80.97c1.5,1.5 3.93,1.515 5.43,0.015l23.13,-22.935c1.515,-1.5 1.53,-3.93 0.03,-5.445l-54.66,-55.095l55.11,-54.66c1.5,-1.5 1.515,-3.93 0.015,-5.43l-22.935,-23.13c-0.735,-0.75 -1.74,-1.155 -2.775,-1.14z"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
                {{ prev.name[locale] }}
              </router-link>
              <router-link
                v-if="next.id"
                :to="'/' + locale + '/project/' + next.id"
                class="btn btn-primary"
              >
                {{ next.name[locale] }}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="26"
                  height="26"
                  viewBox="0 0 192 192"
                  style=" fill:#000000;"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,192v-192h192v192z" fill="none"></path>
                    <g fill="#ffffff">
                      <g id="surface1">
                        <path
                          d="M69.645,11.52c-1.005,0.015 -1.95,0.405 -2.67,1.11l-23.13,22.95c-1.5,1.5 -1.515,3.93 -0.03,5.43l54.66,55.11l-55.095,54.66c-1.515,1.5 -1.53,3.93 -0.03,5.43l22.95,23.13c1.5,1.515 3.93,1.53 5.43,0.03l80.97,-80.31c1.5,-1.5 1.515,-3.93 0.015,-5.445l-80.295,-80.955c-0.735,-0.75 -1.74,-1.155 -2.775,-1.14z"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";

export default {
  computed: {
    currentItem() {
      let projects = this.$store.state.GlobalData.projects;
      let url = this.$route.params.id;
      return projects.find(f => f.id === url);
    }
  },
  data() {
    return {
      locale: this.$route.params.locale,
      index: null,
      imageTarget: [],
      item: {},
      prev: {},
      next: {},
    };
  },
  methods: {
    ChangeImage: function (index) {
      this.index = index;
      this.imageTarget = [];
      for (var i = 0; i < this.currentItem.images.length; i++) {
        this.imageTarget.push(this.currentItem.images[i]);
      }
    },
    parseItem() {
      let items = this.$store.state.GlobalData.projects;
      for (var i = 0; i < items.length; i++) {
        if (items[i].id === this.$route.params.id) {
          this.item = items[i];
          if (items[i - 1]) {
            this.prev.name = items[i - 1].name;
            this.prev.id = items[i - 1].id;
          } else {
            this.prev = {};
          }
          if (items[i + 1]) {
            this.next.name = items[i + 1].name;
            this.next.id = items[i + 1].id;
          } else {
            this.next = {};
          }
        }
      }
    },
  },
  async created() {
    this.parseItem();
  },
  watch: {
    $route(to) {
      this.parseItem();
      this.locale = to.params.locale;
    },
  },
  components: {
    VueGallery,
  },
};
</script>
